import { Flex, VStack } from "@chakra-ui/react";
import { EmailTemplate } from "features/Resources/EmailTemplate/models";
import { ShowTrigger } from "features/Resources/Shared/Components/Fields/TriggerField";
import { ShowSubject } from "features/Resources/Email/Components/Fields/SubjectField";
import { ShowEmailRecipients } from "features/Resources/Email/Components/Fields/EmailRecipientsField";
import { ShowPrebuiltPaths } from "features/Resources/Shared/Components/Fields/PathsField";
import { ShowName } from "features/Resources/Shared/Components/Fields/NameField";
import { ActionTypeTag } from "design-system";
import { ShowRichText } from "components/FormElements/Fields/RichTextAreaField";

export default function PrebuiltEmailTemplateDisplay({
  prebuiltEmailTemplate,
}: {
  prebuiltEmailTemplate: EmailTemplate;
}) {
  return (
    <VStack spacing={4} align="stretch" width="100%">
      <Flex w="100%" justify="space-between" align="center" height="40px">
        <ShowName name={prebuiltEmailTemplate?.name} />
        <ActionTypeTag.Badge actionType="email" />
      </Flex>
      <ShowPrebuiltPaths prebuiltPathIds={prebuiltEmailTemplate?.pathIds} />
      {prebuiltEmailTemplate?.to && <ShowEmailRecipients recipients={prebuiltEmailTemplate?.to} label="To" />}
      {prebuiltEmailTemplate?.cc && <ShowEmailRecipients recipients={prebuiltEmailTemplate?.cc} label="cc" />}
      {prebuiltEmailTemplate?.bcc && <ShowEmailRecipients recipients={prebuiltEmailTemplate?.bcc} label="bcc" />}
      <ShowTrigger label="Send At" trigger={prebuiltEmailTemplate?.deliverAtTrigger} />
      <ShowSubject subject={prebuiltEmailTemplate?.subject} />
      <ShowRichText label="Body" richText={prebuiltEmailTemplate.bodyDisplay ?? prebuiltEmailTemplate.body} />
    </VStack>
  );
}
